import styled from 'styled-components';

const ChatContainer = styled.div`
  max-width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
`;

const ChannelContainer = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
`;

export {
  ChatContainer,
  ChannelContainer,
};
